import { render, staticRenderFns } from "./PrePdfRecords.vue?vue&type=template&id=a1851696&scoped=true&"
import script from "./PrePdfRecords.vue?vue&type=script&lang=ts&"
export * from "./PrePdfRecords.vue?vue&type=script&lang=ts&"
import style0 from "./PrePdfRecords.vue?vue&type=style&index=0&id=a1851696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1851696",
  null
  
)

export default component.exports